/* Round 10 (30 Sep, Jono): a product card's Add to bag must not vanish the moment the cursor slips just below it.
   With a mouse, the last card hovered stays "hot" (price and Add to bag shown) until the cursor moves more than
   SLOP px clear of that card, another card is hovered, or the cursor leaves the window. CSS: .product-card.is-hot. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  var SLOP = 64;
  var hot = null;
  function set(card) {
    if (hot === card) return;
    if (hot) hot.classList.remove('is-hot');
    hot = card;
    if (card) card.classList.add('is-hot');
  }
  document.addEventListener('pointerover', function (e) {
    var card = e.target.closest && e.target.closest('.product-card');
    if (card) set(card);
  }, { passive: true });
  document.addEventListener('pointermove', function (e) {
    if (!hot || hot.contains(e.target)) return;
    if (!hot.isConnected) { hot = null; return; }
    var r = hot.getBoundingClientRect();
    var dx = Math.max(r.left - e.clientX, 0, e.clientX - r.right);
    var dy = Math.max(r.top - e.clientY, 0, e.clientY - r.bottom);
    if (dx > SLOP || dy > SLOP) set(null);
  }, { passive: true });
  document.documentElement.addEventListener('mouseleave', function () { set(null); });
})();
